(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["free-designs-links"] && !Shopify.designMode) return;
  try {
    
(function(){
  function normalize(value){
    return (value || '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').replace(/\s+/g,' ').trim();
  }
  function compareText(a,b){
    return String(a || '').localeCompare(String(b || ''),undefined,{sensitivity:'base',numeric:true});
  }

  var SAVED_DESIGNS_KEY='stc.savedDesigns.v1';

  function readSavedDesigns(){
    try{
      var value=window.localStorage.getItem(SAVED_DESIGNS_KEY);
      var parsed=value ? JSON.parse(value) : [];
      return Array.isArray(parsed) ? parsed : [];
    }catch(error){
      return [];
    }
  }

  function writeSavedDesigns(designs){
    try{
      window.localStorage.setItem(SAVED_DESIGNS_KEY,JSON.stringify(designs));
      document.dispatchEvent(new CustomEvent('stc:saved-designs:changed',{detail:{designs:designs}}));
      return true;
    }catch(error){
      return false;
    }
  }

  function hasSavedDesign(id){
    return readSavedDesigns().some(function(item){ return String(item.id)===String(id); });
  }

  function updateSaveButton(button,isSaved){
    if(!button) return;
    button.classList.toggle('is-saved',isSaved);
    button.setAttribute('aria-pressed',isSaved?'true':'false');
    button.textContent=isSaved?'✓ Design Saved':(button.getAttribute('data-default-label')||'Save Design');
  }

  function init(root){
    if(!root || root.dataset.fdInitialized==='true') return;
    root.dataset.fdInitialized='true';
    var library=root.querySelector('[data-fd-library]');
    var empty=root.querySelector('[data-fd-empty]');
    var input=root.querySelector('.fd-search');
    var results=root.querySelector('.fd-results__text');
    var nav=root.querySelector('[data-fd-category-nav]');
    var stickyTools=root.querySelector('[data-fd-sticky-tools]');

    var headerSection=document.querySelector('.section-header');
    var stickyOffsetFrame=null;

    function updateStickyOffset(){
      if(stickyOffsetFrame) window.cancelAnimationFrame(stickyOffsetFrame);

      stickyOffsetFrame=window.requestAnimationFrame(function(){
        var visibleHeaderBottom=0;

        if(headerSection){
          var rect=headerSection.getBoundingClientRect();
          visibleHeaderBottom=Math.max(0,Math.ceil(rect.bottom));
        }

        var stickyToolsHeight=stickyTools ? Math.ceil(stickyTools.getBoundingClientRect().height) : 0;
        root.style.setProperty('--fd-sticky-top',visibleHeaderBottom+'px');
        root.style.setProperty('--fd-anchor-offset',(visibleHeaderBottom+stickyToolsHeight+16)+'px');
      });
    }

    updateStickyOffset();
    window.addEventListener('resize',updateStickyOffset);
    window.addEventListener('scroll',updateStickyOffset,{passive:true});

    if(headerSection && 'MutationObserver' in window){
      var headerStateObserver=new MutationObserver(updateStickyOffset);
      headerStateObserver.observe(headerSection,{
        attributes:true,
        attributeFilter:['class','style']
      });
    }

    if(stickyTools && 'ResizeObserver' in window){
      var stickyToolsObserver=new ResizeObserver(updateStickyOffset);
      stickyToolsObserver.observe(stickyTools);
    }

    var initialPerCategory=parseInt(library ? library.getAttribute('data-initial-per-category') : '10',10) || 10;
    var columnsPerRow=parseInt(library ? library.getAttribute('data-columns') : '5',10) || 5;
    root.style.setProperty('--fd-columns',String(columnsPerRow));
    var cards=Array.prototype.slice.call(root.querySelectorAll('[data-fd-card]'));
    var saveButtons=Array.prototype.slice.call(root.querySelectorAll('[data-save-design]'));

    function toggleSavedDesign(button){
      if(!button || button.dataset.fdSaveBusy==='true') return;

      var id=button.getAttribute('data-design-id');
      if(!id) return;

      button.dataset.fdSaveBusy='true';

      var designs=readSavedDesigns();
      var exists=designs.some(function(item){ return String(item.id)===String(id); });

      if(exists){
        designs=designs.filter(function(item){ return String(item.id)!==String(id); });

        if(!writeSavedDesigns(designs)){
          button.textContent='Try Again';
          window.setTimeout(function(){
            updateSaveButton(button,true);
            button.dataset.fdSaveBusy='false';
          },2200);
          return;
        }

        updateSaveButton(button,false);
        button.dataset.fdSaveBusy='false';
        return;
      }

      designs.push({
        id:id,
        name:button.getAttribute('data-design-name')||id,
        fileUrl:button.getAttribute('data-design-url')||'',
        previewUrl:button.getAttribute('data-design-preview')||'',
        category:button.getAttribute('data-design-category')||''
      });

      if(!writeSavedDesigns(designs)){
        button.textContent='Try Again';
        window.setTimeout(function(){
          updateSaveButton(button,false);
          button.dataset.fdSaveBusy='false';
        },2200);
        return;
      }

      updateSaveButton(button,true);
      button.dataset.fdSaveBusy='false';
    }

    saveButtons.forEach(function(button){
      updateSaveButton(button,hasSavedDesign(button.getAttribute('data-design-id')));

      if(button.dataset.fdSaveBound==='true') return;
      button.dataset.fdSaveBound='true';

      button.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        toggleSavedDesign(button);
      });
    });
    if(!library) return;
    if(!cards.length){ if(empty) empty.hidden=false; if(results) results.textContent='0 designs available'; return; }

    var categoryMap={};
    cards.forEach(function(card){
      var rawCategory=card.getAttribute('data-category')||'uncategorized';
      var key=normalize(rawCategory)||'uncategorized';
      var label=(card.getAttribute('data-category-label')||'Uncategorized').trim();
      if(!categoryMap[key]){
        var group=document.createElement('section');
        group.className='fd-category-group';
        group.setAttribute('data-category-key',key);
        group.id='fd-category-'+key.replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');

        var headingRow=document.createElement('div');
        headingRow.className='fd-category-heading';

        var heading=document.createElement('h2');
        heading.className='fd-category';
        heading.textContent=label;

        var count=document.createElement('span');
        count.className='fd-category-count';

        var grid=document.createElement('div');
        grid.className='fd-grid';
        grid.setAttribute('data-category-grid',key);

        headingRow.appendChild(heading);
        headingRow.appendChild(count);
        group.appendChild(headingRow);
        group.appendChild(grid);

        categoryMap[key]={label:label,group:group,grid:grid,count:count,toggle:null,expanded:false,total:0};
      }
      categoryMap[key].grid.appendChild(card);
    });

    library.innerHTML='';
    var orderedKeys=Object.keys(categoryMap).sort(function(a,b){
      return compareText(categoryMap[a].label,categoryMap[b].label);
    });

    orderedKeys.forEach(function(key){
      var item=categoryMap[key];
      var itemCards=Array.prototype.slice.call(item.grid.querySelectorAll('[data-fd-card]')).sort(function(a,b){
        return compareText(a.getAttribute('data-display-name'),b.getAttribute('data-display-name'));
      });

      item.total=itemCards.length;

      itemCards.forEach(function(card,index){
        card.setAttribute('data-category-index',String(index));
        item.grid.appendChild(card);
      });

      item.count.textContent='('+item.total+')';

      if(item.total>initialPerCategory){
        var toggle=document.createElement('button');
        toggle.type='button';
        toggle.className='fd-category-toggle';
        toggle.setAttribute('aria-expanded','false');
        toggle.textContent='View '+(item.total-initialPerCategory)+' More →';

        toggle.addEventListener('click',function(){
          item.expanded=!item.expanded;
          toggle.setAttribute('aria-expanded',item.expanded?'true':'false');
          toggle.textContent=item.expanded ? '▲ Show Less' : 'View '+(item.total-initialPerCategory)+' More →';
          applyFilter();
        });

        item.toggle=toggle;
        item.group.appendChild(toggle);
      }

      library.appendChild(item.group);
    });

    if(nav){
      nav.innerHTML='';
      orderedKeys.forEach(function(key){
        var item=categoryMap[key];
        var link=document.createElement('a');
        link.className='fd-category-nav__link';
        link.href='#'+item.group.id;
        link.textContent=item.label+' ('+item.total+')';
        link.addEventListener('click',function(event){
          event.preventDefault();

          var headerSection=document.querySelector('.section-header');
          var visibleHeaderBottom=0;

          if(headerSection){
            var headerRect=headerSection.getBoundingClientRect();
            visibleHeaderBottom=Math.max(0,Math.ceil(headerRect.bottom));
          }

          var stickyToolsHeight=stickyTools ? Math.ceil(stickyTools.getBoundingClientRect().height) : 0;
          var extraOffset=parseInt(root.getAttribute('data-scroll-offset')||'0',10) || 0;
          var top=item.group.getBoundingClientRect().top
            + window.pageYOffset
            - visibleHeaderBottom
            - stickyToolsHeight
            - extraOffset
            - 12;

          setActiveCategory(key);
          window.scrollTo({top:Math.max(0,top),behavior:'smooth'});

          if(history.replaceState){
            history.replaceState(null,'','#'+item.group.id);
          }
        });
        nav.appendChild(link);
      });
    }

    function setActiveCategory(key){
      if(!nav) return;
      var targetId='#fd-category-'+key.replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
      var links=Array.prototype.slice.call(nav.querySelectorAll('.fd-category-nav__link'));

      links.forEach(function(link){
        var isActive=link.getAttribute('href')===targetId;
        link.classList.toggle('is-active',isActive);

        if(isActive){
          link.setAttribute('aria-current','true');
          var left=link.offsetLeft-(nav.clientWidth-link.offsetWidth)/2;
          nav.scrollTo({left:Math.max(0,left),behavior:'smooth'});
        }else{
          link.removeAttribute('aria-current');
        }
      });
    }

    if('IntersectionObserver' in window){
      var visibleCategories={};

      var categoryObserver=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          var key=entry.target.getAttribute('data-category-key');

          if(entry.isIntersecting){
            visibleCategories[key]=entry.intersectionRatio;
          }else{
            delete visibleCategories[key];
          }
        });

        var activeKey=Object.keys(visibleCategories).sort(function(a,b){
          return visibleCategories[b]-visibleCategories[a];
        })[0];

        if(activeKey) setActiveCategory(activeKey);
      },{
        root:null,
        rootMargin:'-28% 0px -62% 0px',
        threshold:[0,.01,.1,.25,.5,.75,1]
      });

      orderedKeys.forEach(function(key){
        categoryObserver.observe(categoryMap[key].group);
      });
    }


    var searchIndex=cards.map(function(card){
      return {card:card,text:normalize([card.getAttribute('data-display-name'),card.getAttribute('data-category'),card.getAttribute('data-keywords')].join(' '))};
    });
    function applyFilter(){
      var query=normalize(input?input.value:'');
      var shown=0;

      searchIndex.forEach(function(item){
        var rawCategory=item.card.getAttribute('data-category')||'uncategorized';
        var categoryKey=normalize(rawCategory)||'uncategorized';
        var categoryItem=categoryMap[categoryKey];
        var index=parseInt(item.card.getAttribute('data-category-index')||'0',10);
        var searchMatch=!query || item.text.indexOf(query)>-1;
        var withinCollapsedLimit=query || !categoryItem || categoryItem.expanded || index<initialPerCategory;
        var visible=searchMatch && withinCollapsedLimit;

        item.card.classList.toggle('is-hidden',!visible);
        if(searchMatch) shown++;
      });

      Object.keys(categoryMap).forEach(function(key){
        var item=categoryMap[key];
        var allCards=Array.prototype.slice.call(item.grid.querySelectorAll('[data-fd-card]'));
        var matchingCards=allCards.filter(function(card){
          var indexed=searchIndex.find(function(entry){ return entry.card===card; });
          return indexed && (!query || indexed.text.indexOf(query)>-1);
        });

        item.group.classList.toggle('is-hidden',matchingCards.length===0);

        if(item.toggle){
          if(query){
            item.toggle.style.display='none';
          }else{
            item.toggle.style.display='flex';
            item.toggle.textContent=item.expanded ? '▲ Show Less' : 'View '+(item.total-initialPerCategory)+' More →';
          }
        }
      });

      if(results){
        results.textContent=query
          ? shown+' result'+(shown===1?'':'s')+' for “'+input.value.trim()+'”'
          : cards.length+' design'+(cards.length===1?'':'s')+' available';
      }
    }
    if(input){ var timer; input.addEventListener('input',function(){ window.clearTimeout(timer); timer=window.setTimeout(applyFilter,80); }); }
    applyFilter();
  }
  document.addEventListener('stc:saved-designs:changed',function(){
    document.querySelectorAll('[data-save-design]').forEach(function(button){
      updateSaveButton(button,hasSavedDesign(button.getAttribute('data-design-id')));
    });
  });

  window.addEventListener('storage',function(event){
    if(event.key!==SAVED_DESIGNS_KEY) return;
    document.querySelectorAll('[data-save-design]').forEach(function(button){
      updateSaveButton(button,hasSavedDesign(button.getAttribute('data-design-id')));
    });
  });

  function initAll(){ document.querySelectorAll('.free-designs').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load',function(event){ init(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.headerHeightHandler = this.setHeaderHeight.bind(this);
      this.headerBreakpoint = window.matchMedia('(max-width: 990px)');

      this.setHeaderHeight();

      this.headerBreakpoint.addEventListener('change', this.headerHeightHandler);
      if ('ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver(this.headerHeightHandler);
        this.headerResizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerBreakpoint.removeEventListener('change', this.headerHeightHandler);
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["random-product-swap"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('random-product-swap')) {
    class RandomProductSwap extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.grid = this.querySelector('[data-random-product-grid]');
        this.button = this.querySelector('[data-random-product-swap-button]');
        this.sectionId = this.dataset.sectionId;
        this.pageCount = Number.parseInt(this.dataset.pageCount, 10) || 1;
        this.pool = this.uniqueCards(this.collectCards(this));
        if (!this.grid || !this.button) return;
        this.defaultButtonLabel = this.button.textContent.trim();
        this.button.addEventListener('click', () => this.swapProducts());
        if (this.pool.length <= 3 && this.pageCount <= 1) {
          this.button.hidden = true;
          return;
        }
        this.swapProducts();
      }

      collectCards(root) {
        if (!root) return [];
        return Array.from(root.querySelectorAll('[data-random-product-card]')).map((card) => card.cloneNode(true));
      }

      uniqueCards(cards) {
        const seen = new Set();
        return cards.filter((card) => {
          const id = card.dataset.productId;
          if (!id || seen.has(id)) return false;
          seen.add(id);
          return true;
        });
      }

      shuffle(cards) {
        const shuffled = cards.slice();
        for (let index = shuffled.length - 1; index > 0; index -= 1) {
          const swapIndex = Math.floor(Math.random() * (index + 1));
          [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
        }
        return shuffled;
      }

      visibleProductIds() {
        return new Set(
          Array.from(this.grid.querySelectorAll('[data-random-product-card]')).map((card) => card.dataset.productId)
        );
      }

      async fetchRandomPage() {
        if (this.pageCount <= 1) return [];
        const page = Math.floor(Math.random() * this.pageCount) + 1;
        const url = new URL(window.location.pathname, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);
        url.searchParams.set('page', String(page));
        const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Product swap request failed');
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        return this.collectCards(parsed.querySelector('random-product-swap'));
      }

      async swapProducts() {
        if (this.loading) return;
        this.loading = true;
        this.classList.add('is-loading');
        this.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        this.button.textContent = this.button.dataset.loadingLabel;

        try {
          const fetchedCards = await this.fetchRandomPage();
          this.pool = this.uniqueCards(fetchedCards.concat(this.pool)).slice(0, 120);
          const visibleIds = this.visibleProductIds();
          let candidates = this.pool.filter((card) => !visibleIds.has(card.dataset.productId));
          if (candidates.length < 3) candidates = this.pool;
          const selectedCards = this.shuffle(candidates).slice(0, 3).map((card) => {
            const clone = card.cloneNode(true);
            clone.hidden = false;
            clone.removeAttribute('hidden');
            return clone;
          });
          const updateGrid = () => this.grid.replaceChildren(...selectedCards);
          if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            await document.startViewTransition(updateGrid).finished;
          } else {
            updateGrid();
          }
        } catch (error) {
          const fallbackCards = this.shuffle(this.pool).slice(0, 3).map((card) => {
            const clone = card.cloneNode(true);
            clone.hidden = false;
            clone.removeAttribute('hidden');
            return clone;
          });
          this.grid.replaceChildren(...fallbackCards);
        } finally {
          this.loading = false;
          this.classList.remove('is-loading');
          this.removeAttribute('aria-busy');
          this.button.disabled = false;
          this.button.textContent = this.defaultButtonLabel;
        }
      }
    }

    customElements.define('random-product-swap', RandomProductSwap);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selected-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class StcSelectedReviews extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const grid = this.querySelector(".stc-reviews__grid");
      if (!grid) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const reviews = Array.from(grid.querySelectorAll('figure'));
      const more = grid.querySelector('.stc-reviews__more');
      if (this.dataset.editor !== "true" && this.dataset.randomize === "true" && !this.shuffled) {
        for (let i = reviews.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [reviews[i], reviews[j]] = [reviews[j], reviews[i]];
        }
        reviews.forEach(card => grid.appendChild(card));
        if (more) grid.appendChild(more);
        grid.scrollLeft = 0;
        this.shuffled = true;
      }
      const controls = this.querySelector('.stc-reviews__controls');
      const previous = controls.querySelector('[data-direction="-1"]');
      const next = controls.querySelector('[data-direction="1"]');
      const cards = Array.from(grid.querySelectorAll('.stc-reviews__card'));
      const dots = controls.querySelector('.stc-reviews__dots');
      let perPage = 0;
      let page = 0;
      const step = () => cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(grid).columnGap);
      const update = () => {
        if (!cards.length) { controls.hidden = true; return; }
        const count = Math.max(1, Math.round((grid.clientWidth + parseFloat(getComputedStyle(grid).columnGap)) / step()));
        const pages = Math.ceil(cards.length / count);
        if (perPage !== count) {
          perPage = count;
          grid.querySelectorAll('.stc-reviews__spacer').forEach(el => el.remove());
          for (let i = 0; i < (count - cards.length % count) % count; i++) {
            const spacer = document.createElement('div');
            spacer.className = 'stc-reviews__spacer';
            spacer.setAttribute('aria-hidden', 'true');
            grid.appendChild(spacer);
          }
          cards.forEach((card, index) => { card.style.scrollSnapAlign = index % count === 0 ? 'start' : 'none'; });
          dots.replaceChildren();
          for (let i = 0; i < pages; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.dataset.page = i;
            dot.setAttribute('aria-label', `${dots.dataset.pageLabel} ${i + 1}`);
            dot.setAttribute('aria-controls', grid.id);
            dots.appendChild(dot);
          }
        }
        page = Math.min(pages - 1, Math.max(0, Math.round(grid.scrollLeft / (step() * count))));
        controls.hidden = cards.length <= count;
        previous.disabled = page === 0;
        next.disabled = page === pages - 1;
        Array.from(dots.children).forEach((dot, index) => dot.setAttribute('aria-current', index === page ? 'true' : 'false'));
      };
      controls.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        const target = button.dataset.page !== undefined ? Number(button.dataset.page) : page + Number(button.dataset.direction);
        grid.scrollTo({ left: target * perPage * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      grid.addEventListener('scroll', update, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.stc-reviews__card');
        if (card) grid.scrollBy({ left: card.getBoundingClientRect().left - grid.getBoundingClientRect().left, behavior: 'instant' });
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(grid);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  }
  if (!customElements.get("stc-selected-reviews")) {
    customElements.define("stc-selected-reviews", StcSelectedReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
